<template>
  <v-tooltip
    :label="props.label"
    :type="props.type"
    :active="props.active"
    :position="props.position"
  >
    <slot />
  </v-tooltip>
</template>

<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  type: {
    type: Boolean,
    required: true,
  },
  active: {
    type: Boolean,
    required: true,
  },
  position: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
// render \n as a new line in tooltip
.tooltip:after {
  white-space: pre;
}
</style>
